{
  "pipes": {
    "appointment_status": {
      "BLOCKER": "Blokátor",
      "CONFIRMED": "Potvrzeno",
      "CHECKED_IN": "Checked in",
      "FULFILLED": "Checked out",
      "BO_CANCELLED": "Salon zrušen",
      "CUSTOMER_CANCELLED": "Zákazník zrušil",
      "EXPIRED": "Vypršela platnost",
      "OTHER": "Další"
    },
    "booking_type": {
      "BLOCKER": "Blokátor",
      "AGENT": "AI Agent",
      "TELEPHONE": "Telefon",
      "ONLINE": "Internet",
      "TREATWELL": "Treatwell",
      "RWG": "Google"
    },
    "communication_way": {
      "EMAIL": "Email",
      "SMS": "SMS",
      "no_matter": "Bez ohledu na to"
    },
    "customer_type": {
      "vip": "VIP",
      "new": "Nový zákazník",
      "regular": "Stálý zákazník",
      "at_risk": "Ohrožený zákazník",
      "normal": "Běžný zákazník"
    },
    "language": {
      "cs-CZ": "Česky",
      "de-DE": "Němčina",
      "fr-FR": "Francouzština",
      "en-US": "Angličtina",
      "vi-VN": "Vietnamština"
    },
    "month": [
      "Leden",
      "Únor",
      "Březen",
      "Duben",
      "Květen",
      "Červen",
      "Červenec",
      "Srpen",
      "Září",
      "Říjen",
      "Listopad",
      "Prosinec"
    ],
    "notification_type": {
      "NEW_APPOINTMENT": "Nové jmenování",
      "APPOINTMENT_CANCELLED": "Zrušení schůzky zákazníkem",
      "APPOINTMENT_MESSAGE": "Nová zpráva",
      "BO_UPDATED": "Aktualizace schůzky v salonu",
      "BO_CANCELLED": "Zrušení schůzky ze strany salonu"
    },
    "weekday": {
      "MONDAY": "Pondělí",
      "TUESDAY": "Úterý",
      "WEDNESDAY": "Středa",
      "THURSDAY": "Čtvrtek",
      "FRIDAY": "Pátek",
      "SATURDAY": "Sobota",
      "SUNDAY": "Neděle"
    },
    "weekday_short": {
      "MONDAY": "Po.",
      "TUESDAY": "Út.",
      "WEDNESDAY": "St.",
      "THURSDAY": "Čt.",
      "FRIDAY": "Pá.",
      "SATURDAY": "So.",
      "SUNDAY": "Ne."
    },
    "review_type": {
      "all": "Všechny recenze",
      "internal_only": "Pouze interní recenze",
      "google_only": "Pouze recenze Google"
    },
    "time": {
      "day": "den",
      "days": "dny",
      "hour": "hodina",
      "hours": "hodin",
      "minute": "minuta",
      "minutes": "minuty",
      "month": "měsíc",
      "months": "měsíce",
      "now": "nyní",
      "second": "druhý",
      "seconds": "sekundy",
      "year": "rok",
      "years": "let",
      "timestamp_in_future": "v {{time}}",
      "timestamp_in_the_past": "{{time}} před",
      "today": "dnes"
    },
    "time_period": {
      "all": "Všechny",
      "today": "Dnes",
      "yesterday": "Včera",
      "this_week": "Tento týden",
      "this_month": "Tento měsíc",
      "last_month": "Minulý měsíc",
      "this_quarter": "V tomto čtvrtletí",
      "last_quarter": "Poslední čtvrtletí",
      "this_year": "V letošním roce",
      "last_year": "V loňském roce"
    },
    "text": {
      "deleted-service": "Odstraněná služba",
      "deleted-staff": "Odstraněný personál",
      "deleted-staff-passive": "Vymazaný personál",
      "first-available-staff": "První dostupní zaměstnanci",
      "first-available-staff-passive": "První dostupný personál",
      "other": "další",
      "others": "ostatní",
      "to": "to",
      "walk_in_customer": "Zákazníci přicházející pěšky"
    }
  }
}
